module.exports = require("web3-bzz");